import type { IncomingCall } from 'app/types/incoming-call'
import { PHONE_FIELDS } from 'lib/contactSearch'
import { usPhoneNumber } from 'lib/phone'

/**
 * Deliberately not `Contact.findMatches`: that scores names too, so a CallRail caller id like
 * "Houston Tx" drags in every contact auto-named from one. The card only claims "these people hold
 * this number". Undefined when no phone clause is possible, since that would match the location.
 */
export function phoneMatchSearch(call: Pick<IncomingCall, 'callerPhone' | 'locationId'>): string | undefined {
  const phone = usPhoneNumber(call.callerPhone)
  if (!phone || !call.locationId) return undefined
  const phones = PHONE_FIELDS.map((field) => `${field}:${phone}`).join(` OR `)
  return `(${phones}) AND locationId:${call.locationId}`
}
